module.exports = __webpack_public_path__ + "img/logo.be8e6425.svg";